<template>
  <div>
    <div class="container">
      <el-select
        v-model="coupon_type"
        style="width:200px"
        class="handle-select mr10"
        placeholder="请选择"
        @change="changetype"
      >
        <el-option
          v-for="item in coupon_typeArr"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-button type="primary" icon="el-icon-edit" class="addbutton" @click="addconfig">新增</el-button>
      <el-table
        :data="usersData"
        border
        style="width: 100%"
        v-loading="loading"
        v-show="coupon_type=='drug_reduce'"
      >
        <el-table-column prop="drug_provider_ids" label="药品供应商" width="140">
          <template slot-scope="scope">
            <span>{{ provideType(scope.row.drug_provider_ids) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="标题" width="130">
          <template slot-scope="scope">
            <span>{{ scope.row.title }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="cover" label="封面" width="240">
          <template slot-scope="scope">
            <!-- <span>{{ scope.row.cover }}</span> -->
            <img :src="scope.row.cover" class="scope-cover" alt="加载失败" />
            <!-- <img
            src="https://qn13.tool.lu/202003/06/1216058ObomJXy4cSW7z8c_280x150.png"
            class="scope-cover"
            />-->
          </template>
        </el-table-column>
        <el-table-column prop="content" label="描述" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.content }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="start_time" label="开始时间" width="150">
          <template slot-scope="scope">
            <span>{{ distance(scope.row.start_time) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="end_time" label="结束时间" width="150">
          <template slot-scope="scope">
            <span>{{ distance(scope.row.end_time) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="amount" label="满减值(满足条件金额)" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.amount }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="reduce_amount" label="满减值(优惠金额)" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.reduce_amount }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="receive_count" label="每人可领数量" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.receive_count }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="total_count" label="优惠券总数" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.total_count }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="surplus_count" label="优惠券剩余数量" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.surplus_count }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="receive_count" label="每人可领数量" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.receive_count }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="130">
          <template slot-scope="scope">
            <el-button @click="openArchives(scope.row,scope.$index)" type="text" size="small">修改</el-button>
            <el-button @click="deleteitem(scope.row,scope.$index)" type="text" size="small">删除</el-button>
            <el-button @click="toGetCoupon(scope.row.id)" type="text" size="small">领取</el-button>
            <el-button @click="handleUse(scope.row)" type="text" size="small">使用情况</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-table
        :data="usersData"
        border
        style="width: 100%"
        v-loading="loading"
        v-show="coupon_type=='drug_discount'"
      >
        <el-table-column prop="drug_provider_ids" label="药品供应商" width="140">
          <template slot-scope="scope">
            <span>{{ provideType(scope.row.drug_provider_ids) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="标题" width="130">
          <template slot-scope="scope">
            <span>{{ scope.row.title }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="cover" label="封面" width="240">
          <template slot-scope="scope">
            <!-- <span>{{ scope.row.cover }}</span> -->
            <img :src="scope.row.cover" class="scope-cover" alt="加载失败" />
            <!-- <img
            src="https://qn13.tool.lu/202003/06/1216058ObomJXy4cSW7z8c_280x150.png"
            class="scope-cover"
            />-->
          </template>
        </el-table-column>
        <el-table-column prop="content" label="描述" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.content }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="start_time" label="开始时间" width="150">
          <template slot-scope="scope">
            <span>{{ distance(scope.row.start_time) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="end_time" label="结束时间" width="150">
          <template slot-scope="scope">
            <span>{{ distance(scope.row.end_time) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="receive_count" label="每人可领数量" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.receive_count }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="discount" label="折扣值" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.discount }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="total_count" label="优惠券总数" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.total_count }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="surplus_count" label="优惠券剩余数量" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.surplus_count }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="receive_count" label="每人可领数量" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.receive_count }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.created_at }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="130">
          <template slot-scope="scope">
            <el-button @click="openArchives(scope.row,scope.$index)" type="text" size="small">修改</el-button>
            <el-button @click="deleteitem(scope.row,scope.$index)" type="text" size="small">删除</el-button>
            <el-button @click="toGetCoupon(scope.row.id)" type="text" size="small">领取</el-button>
            <el-button @click="handleUse(scope.row)" type="text" size="small">使用情况</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-table
        :data="usersData"
        border
        style="width: 100%"
        v-loading="loading"
        v-show="coupon_type=='consultation'"
      >
        <el-table-column prop="id" label="ID" width="50" align="center"></el-table-column>
        <el-table-column prop="doctor_ids" label="医生" width="80" align="center">
          <template slot-scope="scope">
            <el-button @click="hanleLookDoctors(scope.row.doctor_ids)" type="text">查看</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="标题" width="130">
          <template slot-scope="scope">
            <span>{{ scope.row.title }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="cover" label="封面" width="240">
          <template slot-scope="scope">
            <!-- <span>{{ scope.row.cover }}</span> -->
            <img :src="scope.row.cover" class="scope-cover" alt="加载失败" />
            <!-- <img
            src="https://qn13.tool.lu/202003/06/1216058ObomJXy4cSW7z8c_280x150.png"
            class="scope-cover"
            />-->
          </template>
        </el-table-column>
        <el-table-column prop="content" label="描述" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.content }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="start_time" label="开始时间" width="150">
          <template slot-scope="scope">
            <span>{{ distance(scope.row.start_time) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="end_time" label="结束时间" width="150">
          <template slot-scope="scope">
            <span>{{ distance(scope.row.end_time) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="receive_count" label="每人可领数量" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.receive_count }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="discount" label="折扣值" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.discount }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="total_count" label="优惠券总数" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.total_count }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="surplus_count" label="优惠券剩余数量" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.surplus_count }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="receive_count" label="每人可领数量" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.receive_count }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.created_at }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="130">
          <template slot-scope="scope">
            <el-button @click="openArchives(scope.row,scope.$index)" type="text" size="small">修改</el-button>
            <el-button @click="deleteitem(scope.row,scope.$index)" type="text" size="small">删除</el-button>
            <el-button @click="toGetCoupon(scope.row.id)" type="text" size="small">领取</el-button>
            <el-button @click="handleUse(scope.row)" type="text" size="small">使用情况</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-table
        :data="usersData"
        border
        style="width: 100%"
        v-loading="loading"
        v-show="coupon_type=='coupon_vip'"
      >
        <el-table-column prop="drug_provider_ids" label="药品供应商" width="140">
          <template slot-scope="scope">
            <span>{{ provideType(scope.row.drug_provider_ids) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="vip_type_id" label="会员类型编号" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.vip_type_id }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="标题" width="130">
          <template slot-scope="scope">
            <span>{{ scope.row.title }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="cover" label="封面" width="240">
          <template slot-scope="scope">
            <!-- <span>{{ scope.row.cover }}</span> -->
            <img :src="scope.row.cover" class="scope-cover" alt="加载失败" />
            <!-- <img
            src="https://qn13.tool.lu/202003/06/1216058ObomJXy4cSW7z8c_280x150.png"
            class="scope-cover"
            />-->
          </template>
        </el-table-column>
        <el-table-column prop="content" label="描述" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.content }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="start_time" label="开始时间" width="150">
          <template slot-scope="scope">
            <span>{{ distance(scope.row.start_time) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="end_time" label="结束时间" width="150">
          <template slot-scope="scope">
            <span>{{ distance(scope.row.end_time) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="receive_count" label="每人可领数量" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.receive_count }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="discount" label="折扣值" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.discount }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="total_count" label="优惠券总数" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.total_count }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="surplus_count" label="优惠券剩余数量" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.surplus_count }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="receive_count" label="每人可领数量" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.receive_count }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.created_at }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="130">
          <template slot-scope="scope">
            <el-button @click="openArchives(scope.row,scope.$index)" type="text" size="small">修改</el-button>
            <el-button @click="deleteitem(scope.row,scope.$index)" type="text" size="small">删除</el-button>
            <el-button @click="toGetCoupon(scope.row.id)" type="text" size="small">领取</el-button>
            <el-button @click="handleUse(scope.row)" type="text" size="small">使用情况</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="block" style="margin-top:40px; text-align:center" v-if="totalPages>1">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-count="totalPages"
          :page-size="10"
          :current-page="currentPage"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
      <!-- <div class="config_bg" @click="cleardata" v-show="isshowconfg"></div> -->
      <el-dialog :visible.sync="isshowconfg" width="80%" :close-on-click-modal="false">
        <collocation :putData="changeArr" @putsuccess="resetData"></collocation>
      </el-dialog>
      <el-dialog :visible.sync="lookDoctorsVisible" width="60%" :close-on-click-modal="false">
        <p>{{doctors_text}}</p>
      </el-dialog>

      <el-dialog :visible.sync="useVisible" width="80%" :close-on-click-modal="false">
        <p style="margin-bottom: 20px;">未使用量:{{unuse_count}}<span class="ml50">已使用量:{{used_count}}</span></p>
      <div class="handle-box">
        <el-select
          v-model="useStatusId"
          class="handle-select mr10"
          @change="handleUseSelect"
        >
          <el-option
            v-for="(child, index) in useStatus"
            :key="index"
            :label="child.name"
            :value="child.id"
          ></el-option>
        </el-select>
        <el-input v-model="useKeyword" class="handle-input mr10" style="width:200px" placeholder="请输入手机号"></el-input>
        <el-button type="primary" icon="el-icon-search" @click="handleUseSearch">搜索</el-button>
      </div>
      <el-table
        :data="useData"
        border
        class="table"
        ref="windowMultipleTable"
        header-cell-class-name="table-header"
        v-loading="useLoading"
      >
        <el-table-column prop="nickname" label="昵称" align="center"></el-table-column>
        <el-table-column prop="phone" label="手机号" align="center"></el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            <span>{{ getUseStatus(scope.row.use_status) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="使用时间" align="center" v-if="useStatusId == 2">
          <template slot-scope="scope">
            <span>{{ distance(scope.row.use_time) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="截止时间" align="center">
          <span>{{ distance(use_end_time) }}</span>
        </el-table-column>
        <el-table-column label="领取时间" align="center">
          <template slot-scope="scope">
            <span>{{ distance(scope.row.receive_time) }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination" v-if="useTotalPages > 1">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="useCurrentPage"
          :page-size="usePageSize"
          :total="useTotalCount"
          @current-change="handleUsePageChange"
        ></el-pagination>
      </div>
    </el-dialog>
    </div>
  </div>
</template>
<script>
import coupon_url from '../../../api/couponApiConfig'
import { _ } from "vue-underscore";
import collocation from "./collocation";
import http from "../../../api/pontusApiConfig";
import http2 from "../../../api/dorisApiConfig";
import http3 from '../../../api/iapetusApiConfig'
import $ from "jquery";
export default {
  data() {
    return {
      totalPages: null,
      currentPage: 1,
      usersData: null,
      searchKey: null,
      loading: true,
      changeArr: [],
      isshowconfg: false,
      providers: [],
      coupon_type: "drug_discount",
      coupon_typeArr: [
        {
          value: "drug_discount",
          label: "药品折扣",
        },
        {
          value: "drug_reduce",
          label: "药品满减",
        },
        {
          value: "consultation",
          label: "问诊券",
        },
        {
          value: "coupon_vip",
          label: "vip优惠券",
        },
      ],
      doctors: [],
      lookDoctorsVisible: false,
      doctors_text: '',
      useVisible: false,
      useData: [],
      useId: null,
      useLoading: false,
      useKeyword: 1,
      useStatus: [
        {'name': '未使用', 'id': 1},
        {'name': '已使用', 'id': 2}
      ],
      useStatusId: '',
      useTotalPages: 1,
      useCurrentPage: 1,
      usePageSize: 10,
      useTotalCount: 10,
      use_receive_count: 0,
      unuse_count: 0,
      used_count: 0,
      use_end_time: null
    };
  },
  created() {
    this.getProviderDate();
    this.getlist();
    this.changeArr.push("post");
    let arr = {
      title: "",
      cover: "",
      content: "",
      start_time: "",
      end_time: "",
      count: "",
      receive_count: "",
      created_at: "",
      drug_provider_ids: "",
      discount: ""
    };
    this.changeArr.push(arr);
    this.changeArr.push(this.coupon_type);
    let that = this;
    http3.get("/admin/studios/doctors").then(function(res) {
      _.map(res.data.data, function(item, index){
        that.doctors = that.doctors.concat(item['doctors'])
      });
    });
  },
  components: {
    collocation,
  },
  methods: {
    getUseStatus(id){
      var item = _.filter(this.useStatus, function (selector) {
        return selector.id == id;
      })[0];
      if (item) {
        return item["name"]
      } else {
        return "";
      }
    },
    getUseDate(){
      let that = this;
      that.useLoading = true;
      let params = {
        page: that.useCurrentPage,
        page_size: that.usePageSize
      };
      if(that.useKeyword){
        params['phone'] = that.useKeyword;
      }
      if(that.useStatusId){
        params['use_status'] = that.useStatusId;
      }
      http.get("/admin/coupon/use/"+that.useId, { params: params }).then(function (res) {
        that.useData = res.data.data.coupons;
        that.useCurrentPage = parseInt(res.data.data.current_page);
        that.useTotalPages = res.data.data.total_pages;
        that.useTotalCount = that.useTotalPages*that.usePageSize;
        that.used_count = res.data.data.used_count;
        that.unuse_count = that.use_receive_count - that.used_count;
        that.useLoading = false;
      });
    },
    handleUseSelect() {
      this.useCurrentPage = 1;
      this.getUseDate();
    },
    handleUseSearch() {
      this.useCurrentPage = 1;
      this.getUseDate();
    },
    handleUsePageChange(val) {
      this.useCurrentPage = val;
      this.getUseDate();
    },
    handleUse(row){
      this.useId = row.id;
      this.use_end_time = row.end_time;
      this.use_receive_count = row.total_count - row.surplus_count;
      this.useKeyword = "";
      this.useStatusId = 1;
      this.useCurrentPage = 1;
      this.useData = [];
      this.useVisible = true;
      this.getUseDate();
    },
    toGetCoupon(id){
      window.open(coupon_url+'?id='+id)
    },
    getDoctorName(id) {
      var item = _.filter(this.doctors, function (selector) {
        return selector.id == id;
      })[0];
      if (item) {
        return item["name"]
      } else {
        return "";
      }
    },
    hanleLookDoctors(ids){
      if(ids){
        let that = this;
        let doctors = []
        ids = ids.split(',');
        ids.forEach(function (id) {
            doctors.push(that.getDoctorName(id))
        })
        this.doctors_text = doctors.join(',')
        this.lookDoctorsVisible = true;
      }else{
        this.$message({
            message: '暂无医生',
            type: 'warning'
        });
      }
    },
    provideType(id) {
      var item = _.filter(this.providers, function (selector) {
        // console.log(selector)
        return selector.id == id;
      })[0];
      if (item) {
        if (item["type"] == 1) {
          return item["name"] + "(颗粒)";
        } else {
          return item["name"] + "(饮片)";
        }
      } else {
        return "";
      }
    },
    getProviderDate() {
      let that = this;
      let params = {
        page: 1,
        page_size: 100,
      };
      http2.get("/admin/providers", { params: params }).then(function (res) {
        // that.changeArr.push(res.data.data.providers)
        // console.log(res.data.data)
        that.providers = res.data.data.providers;
      });
    },
    changetype(val) {
      // console.log(val);
      this.coupon_type = val;
      this.currentPage = 1;
      this.loading = true;
      this.getlist();
    },
    resetData(data) {
      // console.log(data)
      if (data == 1) {
        this.getlist();
        this.loading = true;
        this.isshowconfg = false;
      }
    },
    getlist() {
      let that = this;
      let params = {
        coupon_type: this.coupon_type,
        page: this.currentPage,
        page_size: 8,
      };
      //   console.log(params)
      http.get("/admin/coupons", { params }).then(function (res) {
        // console.log(res);
        that.usersData = res.data.data.coupons;
        // console.log(that.usersData);
        that.current_page = res.data.data.current_page;
        that.totalPages = res.data.data.total_pages;
        that.loading = false;
      });
    },
    distance(time) {
      return new Date(time*1000).Format('YYYY-MM-DD hh:mm:ss');
    },
    openArchives(item) {
      this.changeArr = [];
      this.changeArr.push("put");
      let arr = {
        id: item.id,
        service_id: item.service_id,
        title: item.title,
        cover: item.cover,
        content: item.content,
        start_time: item.start_time,
        end_time: item.end_time,
        receive_count: item.receive_count,
        created_at: item.created_at,
        count: item.total_count,
        amount: item.amount,
        reduce_amount: item.reduce_amount,
        drug_provider_ids: item.drug_provider_ids,
        discount: item.discount,
        doctor_ids: item.doctor_ids
      };
      this.changeArr.push(arr);
      this.changeArr.push(this.coupon_type);
      this.isshowconfg = true;
    },
    cleardata() {
      this.changeArr = [];
      this.isshowconfg = false;
    },
    addconfig() {
      this.changeArr = [];
      this.changeArr.push("post");
      let arr = {
        title: "",
        cover: "",
        content: "",
        start_time: "",
        end_time: "",
        count: "",
        receive_count: "",
        created_at: "",
        drug_provider_ids: "",
        discount: "",
      };
      this.changeArr.push(arr);
      this.changeArr.push(this.coupon_type);
      this.isshowconfg = true;
    },
    deleteitem(item) {
      let that = this;
      this.$confirm("是否确认删除此优惠券", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            coupon_id: parseInt(item.id),
            coupon_type:that.coupon_type
          };
          http.delete("admin/coupon", { params }).then(function (res) {
            // console.log(res);
            if (res.data.status_code == 200) {
              that.getlist();
              that.$message({
                type: "success",
                message: "删除成功!",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getlist();
    },
  },
  watch: {
    isshowconfg() {
      //   console.log(val)
      if (this.isshowconfg) {
        $("#app").css({
          overflow: "hidden",
        });
      } else {
        $("#app").removeAttr("style");
      }
    },
  },
};
</script>
<style scoped>
.ml50{
  margin-left: 50px;
}
.msglist {
  width: 100%;
  height: 100%;
}
.config_bg {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
  background: rgba(0, 0, 0, 0.7);
}
.addbutton {
  margin-bottom: 20px;
}
</style>